<template>
    <HamletTable
        :columns="columns"
        :fetch="fetch"
        @onRowClick="edit"
    >
        <template #header-controls>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 btn-icon"
                @click="add"
                v-if="$can('visit', 'administration-supplier-add')"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </template>

        <template #header-label>
            {{ $t('Page(Suppliers):Component(Text):page-label') }}
        </template>

        <template #cell-contacts="data">
            {{ renderContacts(data.item.contacts) }}
        </template>

        <template #cell-validFrom="data">
            {{ data.item.validFrom ? renderDate(data.item.validFrom) : '-' }}
        </template>

        <template #cell-validTo="data">
            {{ data.item.validTo ? renderDate(data.item.validTo) : '-' }}
        </template>
    </HamletTable>
</template>

<script>
import {
    BButton
} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import {SupplyChain} from "@core/api";
import {DateRenderer} from "@core/mixins";
import Ripple from 'vue-ripple-directive'

export default {
    mixins: [DateRenderer],
    directives: {Ripple},
    components: {
        HamletTable,
        BButton,
    },
    data() {
        return {
            columns: [
                {
                    key: 'name',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'state',
                    label: this.$t('Component(Grid):column-state')
                },
                {
                    key: 'contacts',
                    label: this.$t('Component(Grid):column-contact')
                },
                {
                    key: 'validFrom',
                    label: this.$t('Component(Grid):column-valid-from')
                },
                {
                    key: 'validTo',
                    label: this.$t('Component(Grid):column-valid-to')
                },
            ],
        }
    },
    methods: {
        renderContacts(contacts) {
            if (contacts.length > 2) {
                return contacts.splice(0, 2).map(c => c.name).join(', ') + ' ...';
            }

            return contacts.map(c => c.name).join(', ');
        },
        fetch(config, cb) {
            SupplyChain.getSuppliers([], {}, config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items);
            });
        },
        edit(supplier) {
            this.$router.push({
                name: 'administration-supplier-edit',
                params: {type: 'supplier', id: supplier.id}
            });
        },
        add() {
            this.$router.push({
                name: 'administration-supplier-add',
                params: {type: 'supplier'}
            });
        }
    }
}
</script>
